import React from "react";
import {
    Dialog as MuiDialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Box,
    styled,
} from "@mui/material";
import { ReactComponent as Warning } from "../../../assets/img/warningImage.svg";

const Dialog = styled(MuiDialog)(({ theme }) => ({
    "& .MuiDialog-container": {
        "& .MuiDialog-paper": {
            maxWidth: "780px",
            padding: "18px 25px",
        },
    },
}));

const AccountMigrateModal = ({ open, onContinue, onClose }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                <Box
                    display="flex"
                    alignItems="center"
                    flexDirection={"column"}
                    gap={1}
                    mb={1}
                >
                    <Warning width={70} height={70} />
                    <Typography
                        sx={{ fontSize: "26px", fontWeight: 700, color: "#0f172a" }}
                    >
                        You have already enrolled with Kardia
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ px: 4 }}>
                We noticed that you already have a Kardia account with us. Confirming
                the migration will move your existing details into KardiaComplete. All
                your records will be retained. Would you like to migrate over to
                KardiaComplete?
            </DialogContent>
            <DialogActions>
                <Button onClick={onContinue} variant="contained" fullWidth>
                    yes, migrate profile
                </Button>
                <Button onClick={onClose} variant="outlined" fullWidth>
                    no, do not migrate
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AccountMigrateModal;
